import React, { useEffect } from 'react';
import { useContext } from 'react';
import LiveLoader from './LiveLoader';
import { getConfiguration } from '../data/utils/configuration';
import { usePoll } from '../data/fetch/useFetch';
import { parseLiveData } from '../data/parseLiveData';
import { Outlet } from 'react-router-dom';
import { useSetSection } from '../common/SectionProvider';

export let interceptorData = null;

export const LiveDataContext = new React.createContext(null);

export function useLiveData() {
    return useContext(LiveDataContext);
}

export default function LiveDataProvider() {
    const conf = getConfiguration();
    useSetSection('live');

    useEffect(() =>
        () => { interceptorData = null }
    , []);

    const [, isError, data] = usePoll(conf.api.getMenuLiveSingleMatchPage, null, (data => {
        const parsedData = parseLiveData(data);
        interceptorData = {
            isError: false,
            payload: parsedData
        };
        window.dispatchEvent(new CustomEvent('xs-live-update', {'detail': interceptorData}));
        return parsedData;
    }));

    if (isError) {
        interceptorData = {isError: true};
        window.dispatchEvent(new CustomEvent('xs-live-update', {'detail': interceptorData}));
        return <LiveLoader isError={true} />
    }

    return (
        <LiveDataContext.Provider value={data}>
            <Outlet />
        </LiveDataContext.Provider>
    );
}
